var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRedArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 11.0003L13.5493 2.95109C13.8174 2.68297 14.2519 2.68297 14.5214 2.95109C14.7895 3.22059 14.7895 3.65509 14.5214 3.92459L7.44425 11.0003L14.5214 18.0761C14.7895 18.3456 14.7895 18.7801 14.5214 19.0496C14.2519 19.3177 13.8174 19.3177 13.5493 19.0496L5.5 11.0003Z",
    fill: "#E81111"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRedArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RedArrowLeft.4211a6acfbe1853306a6e7d2c4f09d84.svg";